// no TS annotations—plain JS
import { STAFF_ROLES } from '@/router/access'
import AdminLayout from '@/admin/AdminLayout.vue'         // or skip if you use the public App.vue
import DashboardPage from '@/admin/pages/DashboardPage.vue'
import JobsPage from '@/admin/pages/JobsPage.vue'
import ContactMessagesPage from '@/admin/pages/ContactMessagesPage.vue'
import ApplicationView from '@/admin/pages/ApplicationView.vue'
import AddUserPage from '@/admin/pages/AddUserPage.vue'
import UsersListPage from '@/admin/pages/UsersListPage.vue'
import AddPropertyPage from '@/admin/pages/AddPropertyPage.vue'
import CreateInvoice from '@/admin/pages/CreateInvoice.vue'
import UpdateEmployeePage from '@/admin/pages/UpdateEmployeePage.vue'
import CreatePayStubPage from '@/admin/pages/CreatePayStubPage.vue'


export default [
  {
    path: '/admin',             // base path for all admin screens
    component: AdminLayout,     // optional shell with sidebar/nav
    meta: { requiresAuth: true, roles: STAFF_ROLES }, // every staff role; the sidebar decides which links each sees
    children: [
      {
        path: '',               // /admin
        name: 'AdminDashboard',
        component: DashboardPage
      },
      { path: 'jobs', name: 'AdminJobs', component: JobsPage },
      {
        path: 'messages',
        name: 'AdminMessages',
        component: ContactMessagesPage
      },
      {
        path: '/admin/applications/:id',
        name: 'ApplicationView',
        component: ApplicationView,
        props: true, // so “id” becomes a prop if you want
      },
      {
        path: '/admin/adduser',
        name: 'AddUser',
        component: AddUserPage,

      },
      {
        path: '/admin/listusers',
        name: 'UsersList',
        component: UsersListPage,
      },
      {
        path: '/admin/addproperty',
        name: 'AddProperty',
        component: AddPropertyPage,
      },
      {
        path: '/admin/createinvoice',
        name: 'CreateInvoice',
        component: CreateInvoice,
      },
      {
        path: '/admin/updateemployee',
        name: 'UpdateEmployee',
        component: UpdateEmployeePage,
      },
      {
        path: '/admin/createpaystub',
        name: 'CreatePayStub',
        component: CreatePayStubPage,
      }


    ]
  }
]
// Note: The above code is a Vue.js router configuration for an admin dashboard.
// It defines a route for the admin dashboard with a layout and a child route for the dashboard page itself.